export default function equal(self, other) {
  return self.commandName == other.commandName && self.assetComponentId == other.assetComponentId
}
